import SummaryInfo from "./SummaryInfo";

export default SummaryInfo;